module.exports = __webpack_public_path__ + "img/Trash.e2589315.svg";